/*eslint-disable*/
export default {
  init() {

    // ===== HAMBURGER MENU =====
    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
      $('html').toggleClass('menu-open');
      $('html').ontouchend = (e) => {
        e.preventDefault();
      }
    });

    $('.nav__item--dropdown').click(function () {
      $(this).toggleClass('subnav-mobile');
    });

    $(".wysiwyg iframe").wrap("<div class='wysiwyg__iframe'></div>");

    // ===== POPUP VIDEO  =====

    var popupBtn = $('#playBtn')
    var closeBtn = $('#closeBtn')
    var popup = $('#popup')
    var popups = $('[id^="popup-"]')
    var popupBtns = $('[id^="playBtn-"]')
    var closeBtns = $('[id^="closeBtn-"]')

    popupBtns.each(function() {
      $(this).click(function () {
        var number = $(this).data('number')
        $('[id="popup-' + number + '"]').addClass('header__overlay--active')
      })
    })

    closeBtns.each(function() {
      $(this).click(function () {
        var number = $(this).data('number')
        $('[id="popup-' + number + '"]').removeClass('header__overlay--active')
        $('iframe').each(function(){
          this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
        });
      })
    })
    
    $('iframe').attr('src', function() { return $(this).attr("src") + "&enablejsapi=1" })
    popupBtn.click(function () {
      popup.addClass('header__overlay--active')
    });
    closeBtn.click(function () {
      popup.removeClass('header__overlay--active')
      $('iframe').each(function(){
        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
      });
    });

  




    $(window).resize(function () {
      // Detect the current screen width.
      var width = $(window).width();
      // Determine what you define a as a mobile screen size.
      var mobileScreen = 1024;
      // Check whether the condition applies.
      if (width <= mobileScreen) {
        // Change every href attribute of every a element with #
        $('.nav__item--dropdown #nav-dropdown').attr('href', '#');
        // You can also hide them, if you want, with
        // $('a').hide();
      } else {
        // Do nothing otherwise, 
        // or change the href attribute back to an actual url, using ids.
      }
    }).resize();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
